module.exports = __webpack_public_path__ + "img/b.5cb8bfd2.jpg";